import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useQuery } from '../hooks/useQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Moment from 'moment';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import 'moment/locale/pt-br';
import AddIcon from '@mui/icons-material/Add';

export const NovoFaqPage = (props) => {
  const { criarFaqs, showFaq, atualizarFaq } = useQuery();
  const [loading, setLoading] = React.useState(false);
  const [pergunta, setPergunta] = React.useState();
  const [resposta, setResposta] = React.useState();
  const [ordem, setOrdem] = React.useState();
  const navigate = useNavigate();
  const theme = useTheme();
  let [searchParams, setSearchParams] = useSearchParams();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  React.useEffect(() => {
    if (searchParams.get('faq_id')) {
      getFaq();
    }
  }, []);

  const getFaq = async () => {
    let result = await showFaq(searchParams.get('faq_id'));

    if (result && result.data) {
      setPergunta(result.data.data.pergunta);
      setResposta(result.data.data.resposta);
      setOrdem(result.data.data.ordem);
    }
  };

  const salvar = async () => {
    setLoading(true);

    const result = await criarFaqs({
      pergunta: pergunta,
      resposta: resposta,
      ordem: ordem,
    });

    if (result && result.data) {
      navigate('/dashboard/listar-faq');
    }

    setLoading(false);
  };

  const atualizar = async () => {
    setLoading(true);

    const result = await atualizarFaq(searchParams.get('faq_id'), {
      pergunta: pergunta,
      resposta: resposta,
      ordem: ordem,
    });

    if (result && result.data) {
      console.log(result.data.data);
      navigate('/dashboard/listar-faq');
    }

    setLoading(false);
  };

  const onSubmit = () => {
    if (pergunta && pergunta.length > 0 && resposta && resposta.length > 0) {
      if (searchParams.get('faq_id')) {
        atualizar();
      } else {
        salvar();
      }
    }
  };
  const onChangeTextoPergunta = (event) => {
    setPergunta(event.target.value);
  };

  const onChangeTextoResposta = (event) => {
    setResposta(event.target.value);
  };

  const onChangeOrdem = (event) => {
    setOrdem(event.target.value);
  };

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Criar novo aviso
              </span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12} style={{ paddingTop: 0 }}>
          <strong>Digite a pergunta</strong>
        </Grid>
        <Grid item sm={12}>
          <TextField
            margin="normal"
            value={pergunta}
            onChange={onChangeTextoPergunta}
            multiline
            rows={6}
            fullWidth
            placeholder="Digite aqui"
          />
        </Grid>
        <Grid item sm={12} style={{ paddingTop: 0 }}>
          <strong>Digite a resposta</strong>
        </Grid>
        <Grid item sm={12}>
          <TextField
            margin="normal"
            value={resposta}
            onChange={onChangeTextoResposta}
            multiline
            rows={6}
            fullWidth
            placeholder="Digite aqui"
          />
        </Grid>
        <Grid item sm={12}>
          <label>Ordem</label>
          <TextField
            margin="normal"
            type="number"
            value={ordem}
            onChange={onChangeOrdem}
            fullWidth
            placeholder="Digite aqui"
          />
        </Grid>
        <Grid item sm={12} style={{ paddingTop: 0 }}>
          <Button onClick={onSubmit} variant="contained">
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
